import React from 'react';

/** Private notes visible only to prescribing doctor */
export default function PrivateNotesPanel({ value, onChange, readOnly, doctorName }) {
  return (
    <div className="card private-notes" style={{ borderLeft: '4px solid #6366f1', marginTop: 12 }}>
      <h4 style={{ margin: '0 0 8px', color: '#4f46e5' }}>Private notes</h4>
      <p className="hint" style={{ fontSize: 11, marginBottom: 8 }}>
        Only you can see these — not shown on printed Rx or to reception. Find past private notes in Patient timeline → Private.
      </p>
      <textarea
        className="input"
        rows={4}
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value)}
        readOnly={readOnly}
        placeholder={`Clinical reminders for ${doctorName || 'yourself'}…`}
      />
    </div>
  );
}
